<template>
  <div class="lv-twist-circle">
    <div class="lv-twist-circle_container">
      <div
        class="lv-twist-circle_content"
        :class="{'show-tooltip': _isShowTooltip}"
      >
        <i :class="icon" />
        <LvText
          ref="LvTwistCircleText"
          white
          bold
          h4
          wrap
          class="mt-0 lv-twist-circle__content-text"
        >
          {{ $t(title) }}
        </LvText>
      </div>
      <div
        class="lv-twist-circle_color-wrap"
        :class="color"
      >
        <div class="color" />
        <div class="color" />
        <div class="color" />
        <div class="color" />
        <div class="color" />
      </div>
      <p class="lv-tooltip-wrap"><LvText white>{{$t(title)}}</LvText></p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '高風險',
    },
    icon: {
      type: String,
      default: 'icon-risk-high-filled',
    },
    color: {
      type: String,
      default: 'red',
    },
  },
  data() {
    return {
      textHeight: 0,
      observer: null
    }
  },
  computed: {
    _isShowTooltip() {
      return this.textHeight > 70;
    }
  },
  watch: {
    title: {
      handler() {
        this.$nextTick(() => {
          this.updateTextHeight();
        });
      },
      immediate: true
    }
  },
  mounted() {
    this.updateTextHeight();
    this.setupResizeObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    updateTextHeight() {
      if (this.$refs.LvTwistCircleText) {
        const element = this.$refs.LvTwistCircleText.$el || this.$refs.LvTwistCircleText;
        this.textHeight = element.offsetHeight;
      }
    },
    setupResizeObserver() {
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(entries => {
          for (let entry of entries) {
            this.textHeight = entry.contentRect.height;
          }
        });

        const element = this.$refs.LvTwistCircleText.$el || this.$refs.LvTwistCircleText;
        if (element) {
          this.observer.observe(element);
        }
      }
    }
  }
};
</script>